module.exports = __webpack_public_path__ + "media/src/assets/menu_learning_center-77a6ae7197c031eac509466c382f6a54.jpg";